// extracted by mini-css-extract-plugin
module.exports = {"cardRoot":"EventCard_cardRoot__FlaZl","cardLinkOverlay":"EventCard_cardLinkOverlay__atWiy"};